const API_URL = 'https://api.hristiyana-ivanova.com/create-checkout-session';

export interface CheckoutParams {
  priceId: string;
  name: string;
  email: string;
  date: string;
  inquiry: string;
  isExpress: boolean;
  quantity?: number;
}

function chunkInquiry(
  metadata: Record<string, string>,
  text: string
): Record<string, string> {
  const size = 500;
  const chunks = Math.ceil(text.length / size);
  for (let i = 0; i < chunks; i++) {
    metadata[`inquiry${i + 1}`] = text.slice(i * size, (i + 1) * size);
  }
  return metadata;
}

export function createCheckoutSession({
  priceId,
  name,
  email,
  date,
  inquiry,
  isExpress,
  quantity,
}: CheckoutParams): void {
  const metadata = chunkInquiry({ name, email, date }, inquiry);

  fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ priceId, metadata, isExpress, quantity }),
  })
    .then((res) => res.json())
    .then((data: { url?: string }) => {
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Error creating checkout session');
      }
    })
    .catch((error: unknown) => {
      console.error('Error creating checkout session:', error);
      alert('Error creating checkout session');
    });
}
